<template>
    <div class="sticky-header tw:grid tw:grid-cols-12 tw:items-center" :class="{ 'no-margin-bottom': noMarginBottom, [`tw:bg-[var(${computedBackgroundColor})]`] : true }">
        <!-- Full overwrite slot -->
        <slot name="full-header">
            <div :class="{'tw:col-span-10': ($isMobile || $isTablet), 'tw:col-span-4': !($isMobile || $isTablet)}">
                <h1 class="title tw:truncate">
                    <slot />
                </h1>

                <h2 v-if="$slots.subtitle" class="subtitle">
                    <slot name="subtitle" />
                </h2>
            </div>

            <div :class="{'tw:col-span-2': ($isMobile || $isTablet), 'tw:col-span-8': !($isMobile || $isTablet)}" class="tw:w-full tw:h-full tw:flex tw:items-start tw:justify-end tw:pt-1">
                <!-- Mobile: Show 3-dot button -->
                <button
                    v-if="$slots.actions && ($isMobile || $isTablet)"
                    type="button"
                    class="mobile-actions-button tw:my-auto"
                    aria-label="More actions"
                    @click="showActionsDrawer = true"
                >
                    <i class="uil uil-ellipsis-v" />
                </button>

                <!-- Desktop: Show actions slot -->
                <slot v-else class="tw:my-auto" name="actions" />
            </div>

            <slot name="tabs" />

            <slot name="details" />
        </slot>
    </div>

    <!-- Mobile Actions Drawer -->
    <Drawer
        v-model:visible="showActionsDrawer"
        position="bottom"
        header="Actions"
        class="tw:h-6/8"
        :pt="{
            header: {
                class: 'actions-drawer-header',
            }
        }"
    >
        <div class="tw:grid tw:gap-2 tw:p-2">
            <div class="tw:w-full">
                <slot name="actions" />
            </div>
            <e-button
                class="tw:w-full"
                type="primary"
                outlined
                @click="showActionsDrawer = false"
            >
                Cancel
            </e-button>
        </div>
    </Drawer>
</template>

<script>
export default {
    name: 'StickyHeader',

    props: {
        headerLeft: {
            default: '6',
            type: [String, Number],
        },
        headerRight: {
            default: '6',
            type: [String, Number],
        },
        hideBottomBorder: {
            default: false,
            type: Boolean,
        },
        noMarginBottom: {
            default: false,
            type: Boolean,
        },
        backgroundColor: {
            default: 'surface',
            type: String,
        },
    },

    data: () => ({
        showActionsDrawer: false,
    }),

    computed: {
        computedBackgroundColor() {
            if (this.backgroundColor === 'background') {
                return '--p-content-background';
            }
            return '--surface-ground';
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.sticky-header {
    top: -2rem; // Matches .layout-content padding to reach navbar when stuck
    z-index: 11;
    overflow: visible !important;
    position: sticky;
    position: -webkit-sticky;
    padding-top: 2rem; // Offset the negative top so content isn't hidden
    @include from($navbar-breakpoint) {
        margin-bottom: $main-padding-vertical !important;
        margin-top: calc(-#{$main-padding-vertical}) !important;
        padding-top: calc(2rem + #{$column-gap}); // 2rem offset + original padding
    }

    .subtitle {
        color: var(--text-color);
        margin-top: 0 !important;
    }

    .auto-save {
        justify-content: center;
        margin-left: 0;

        @include from($tablet) {
            justify-content: flex-end;
        }
    }

    &.no-margin-bottom {
        @include from($navbar-breakpoint) {
            margin-bottom: 0 !important;
        }
    }
}

.mobile-actions-button {
    background: var(--p-content-background);
    border: 1px solid var(--p-content-border-color);
    border-radius: var(--p-content-border-radius);
    height: 2.5rem;
    width: 2.5rem;
    cursor: pointer;
    color: var(--p-text-color);
    font-size: 1.5rem;
    transition: color 0.2s ease;

    &:hover {
        color: var(--p-primary-color);
    }

    &:focus {
        outline: 2px solid var(--p-primary-color);
        outline-offset: 2px;
        border-radius: 4px;
    }
}

.actions-drawer-header {
    padding-bottom: 0;
    border-bottom: 1px solid var(--p-content-border-color);
}
</style>
